import React, { useState, useEffect } from "react";
import "./InputSearchs.css";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faMapMarkerAlt, faSpinner } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-modal';
import baseURL from '../url';

export default function InputSearchs() {
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredProducto, setFilteredProducto] = useState([]);
    const [filteredTiendas, setFilteredTiendas] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [noResults, setNoResults] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [tiendas, setTiendas] = useState([]);
    const [productos, setProductos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [categoriasProductos, setCategoriasProductos] = useState([]);
    const [geoLoading, setGeoLoading] = useState(false);
    const [geoActive, setGeoActive] = useState(false);
    const [geoMessage, setGeoMessage] = useState("");
    const [geoError, setGeoError] = useState(false);
    useEffect(() => {
        cargarProductos();
        cargarCategoriaProductos();
        cargarCategoriaTienda();
    }, []);

    const cargarProductos = () => {
        fetch(`${baseURL}/tiendasFrontend.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                const productosTienda = data.tiendas.flatMap(tienda => tienda?.productos || []);
                setTiendas(data.tiendas || []);
                setProductos(productosTienda);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };
    const cargarCategoriaTienda = () => {
        fetch(`${baseURL}/categoriaTiendaGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategorias(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarCategoriaProductos = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoriasProductos(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const handleSearch = (event) => {
        const searchTerm = event.target.value;
        setSearchTerm(searchTerm);

        // Filtrar productos por título o por categoría
        const filteredProductos = productos.filter(producto => {
            const matchesTitle = (producto.titulo || '').toLowerCase().includes(searchTerm.toLowerCase());
            const matchesCategory = categoriasProductos.some(categoria =>
                Number(categoria.idCategoria) === Number(producto.idCategoria) &&
                (categoria.categoria || '').toLowerCase().includes(searchTerm.toLowerCase())
            );
            return matchesTitle || matchesCategory;
        });

        // Filtrar tiendas por nombre o por categoría
        const filteredTiendas = tiendas.filter(tienda => {
            const matchesName = (tienda.nombre || '').toLowerCase().includes(searchTerm.toLowerCase());
            const matchesCategory = categorias.some(categoria =>
                Number(categoria.idCategoria) === Number(tienda.idCategoria) &&
                (categoria.categoria || '').toLowerCase().includes(searchTerm.toLowerCase())
            );
            return matchesName || matchesCategory;
        });

        setFilteredProducto(filteredProductos);
        setFilteredTiendas(filteredTiendas);
        setShowResults(searchTerm !== "");
        setNoResults(searchTerm !== "" && filteredProductos.length === 0 && filteredTiendas.length === 0);
    };


    // Extrae coordenadas lat/lng desde mapa_latitud/mapa_longitud o desde la URL de Google Maps
    const extraerCoordenadas = (tienda) => {
        if (tienda.mapa_latitud && tienda.mapa_longitud) {
            const lat = parseFloat(tienda.mapa_latitud);
            const lng = parseFloat(tienda.mapa_longitud);
            if (!isNaN(lat) && !isNaN(lng)) return { lat, lng };
        }
        if (tienda.mapa) {
            // Patrón !3d(lat)!4d(lng) o !2d(lng)!2d(lat)
            const match3d4d = tienda.mapa.match(/!3d(-?\d+\.\d+)!4d(-?\d+\.\d+)/);
            if (match3d4d) {
                return { lat: parseFloat(match3d4d[1]), lng: parseFloat(match3d4d[2]) };
            }
            // Patrón @(lat),(lng)
            const matchAt = tienda.mapa.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
            if (matchAt) {
                return { lat: parseFloat(matchAt[1]), lng: parseFloat(matchAt[2]) };
            }
            // Patrón dir/(lat),(lng)
            const matchDir = tienda.mapa.match(/dir\/(-?\d+\.\d+),(-?\d+\.\d+)/);
            if (matchDir) {
                return { lat: parseFloat(matchDir[1]), lng: parseFloat(matchDir[2]) };
            }
        }
        return null;
    };

    // Fórmula del Semiverseno (Haversine) para calcular distancia en kilómetros
    const calcularDistanciaKm = (lat1, lon1, lat2, lon2) => {
        const R = 6371; // Radio de la Tierra en km
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = 
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    };

    const formatearDistancia = (km) => {
        if (km === null || km === undefined) return '';
        if (km < 1) {
            const metros = Math.round(km * 1000);
            return `a ${metros} m`;
        }
        return `a ${km.toFixed(1)} km`;
    };

    const handleBuscarLocalesCercanos = () => {
        if (!navigator.geolocation) {
            setGeoError(true);
            setGeoMessage("Tu navegador no soporta geolocalización GPS.");
            return;
        }

        setGeoLoading(true);
        setGeoMessage("");
        setGeoError(false);

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const userLat = position.coords.latitude;
                const userLng = position.coords.longitude;

                const tiendasConDistancia = tiendas.map(tienda => {
                    const coords = extraerCoordenadas(tienda);
                    let distanciaKm = null;
                    if (coords) {
                        distanciaKm = calcularDistanciaKm(userLat, userLng, coords.lat, coords.lng);
                    }
                    return {
                        ...tienda,
                        distanciaKm
                    };
                });

                // Ordenar: primero las que tienen coordenadas de menor a mayor distancia
                tiendasConDistancia.sort((a, b) => {
                    if (a.distanciaKm === null && b.distanciaKm === null) return 0;
                    if (a.distanciaKm === null) return 1;
                    if (b.distanciaKm === null) return -1;
                    return a.distanciaKm - b.distanciaKm;
                });

                setFilteredTiendas(tiendasConDistancia);
                setFilteredProducto([]);
                setShowResults(true);
                setNoResults(tiendasConDistancia.length === 0);
                setGeoActive(true);
                setGeoLoading(false);
                setGeoMessage("📍 Mostrando locales ordenados por cercanía a tu GPS");
            },
            (error) => {
                setGeoLoading(false);
                setGeoError(true);
                let msg = "No se pudo obtener tu ubicación GPS.";
                if (error.code === 1) {
                    msg = "Permiso de ubicación denegado en tu navegador.";
                } else if (error.code === 2) {
                    msg = "Ubicación GPS no disponible actualmente.";
                } else if (error.code === 3) {
                    msg = "Tiempo de espera agotado al obtener el GPS.";
                }
                setGeoMessage(msg);
            },
            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 60000
            }
        );
    };

    const openModal = () => {
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
        setGeoActive(false);
        setGeoMessage("");
        setGeoError(false);
    };

    const handleLinkClick = (url) => {
        closeModal();
        window.location.href = url;
    };

    return (
        <div className="fondo-input">
            <div className="search-container">
                <div className="inputSerch" onClick={openModal} role="button" aria-label="Abrir buscador" tabIndex={0}>
                    <FontAwesomeIcon icon={faSearch} className="search-icon" />
                    <strong>Buscar</strong>
                </div>
                <Modal isOpen={modalIsOpen} onRequestClose={closeModal} className="modalInput" overlayClassName="overlayInput">
                    <fieldset className="inputSearch">
                        <FontAwesomeIcon icon={faSearch} className="search-icon" />
                        <input
                            type="text"
                            placeholder="Buscar tiendas, locales o productos..."
                            value={searchTerm}
                            onChange={handleSearch}
                            className="input"
                            aria-label="Buscar tiendas, locales o productos"
                        />
                    </fieldset>

                    {/* Botón con icono: Locales cerca a mí */}
                    <div className="searchNearbyBar">
                        <button
                            type="button"
                            className={`btnLocalesCerca ${geoLoading ? 'loading' : ''} ${geoActive ? 'active' : ''}`}
                            onClick={handleBuscarLocalesCercanos}
                            title="Buscar tiendas y locales cerca de mi ubicación GPS"
                            aria-label="Buscar tiendas y locales cerca de mi ubicación GPS"
                        >
                            <FontAwesomeIcon icon={geoLoading ? faSpinner : faMapMarkerAlt} spin={geoLoading} />
                            <span>{geoLoading ? 'Detectando tu GPS...' : 'Locales cerca a mí'}</span>
                        </button>
                        {geoMessage && (
                            <p className={`geoFeedbackMessage ${geoError ? 'error' : ''}`}>
                                {geoMessage}
                            </p>
                        )}
                    </div>
                    {showResults && (
                        <div className="modalSearch">
                            {filteredTiendas.length > 0 && (
                                <div className="sectionSearch">
                                    <h3>Tiendas</h3>
                                    <hr />
                                    {filteredTiendas.map(tienda => (
                                        <div key={tienda.idTienda}>
                                            <a href={`/tienda/${tienda.idTienda}/${tienda.nombre.replace(/\s+/g, '-')}`} onClick={() => handleLinkClick(`/tienda/${tienda.idTienda}/${tienda.nombre.replace(/\s+/g, '-')}`)}>
                                                <img src={tienda.imagen1} alt="" />
                                                <div className="searchTiendaInfo">
                                                    <h4>{tienda.nombre}</h4>
                                                    {
                                                        categorias
                                                            .filter(categoriaFiltrada => Number(categoriaFiltrada.idCategoria) === Number(tienda.idCategoria))
                                                            .map(categoriaFiltrada => (
                                                                <h6 key={categoriaFiltrada.idCategoria}> {categoriaFiltrada.categoria}</h6>
                                                            ))
                                                    }
                                                    {tienda.direccion && (
                                                        <span className="searchTiendaDir">{tienda.direccion}</span>
                                                    )}
                                                    {tienda.distanciaKm !== undefined && tienda.distanciaKm !== null && (
                                                        <span className="badgeDistancia">
                                                            <FontAwesomeIcon icon={faMapMarkerAlt} /> {formatearDistancia(tienda.distanciaKm)}
                                                        </span>
                                                    )}
                                                </div>
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {filteredProducto.length > 0 && (
                                <div className="sectionSearch">
                                    <h3>Productos</h3>
                                    <hr />
                                    {filteredProducto.map(item => (
                                        <div key={item.idProducto}>
                                            <Link to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`} onClick={closeModal}>
                                                <img src={item.imagen1} alt="" />
                                                <div>
                                                    <h4>{item.titulo}</h4>
                                                    {
                                                        categoriasProductos
                                                            .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === item.idCategoria)
                                                            .map(categoriaFiltrada => (
                                                                <h6 key={categoriaFiltrada.idCategoria}> {categoriaFiltrada.categoria}</h6>
                                                            ))
                                                    }
                                                </div>
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {noResults && <p>No se encontraron resultados.</p>}
                        </div>
                    )}
                </Modal>
            </div>
        </div>
    );
}
